import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    console.error('Component stack:', errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // In development, show error details
      if (process.env.NODE_ENV === 'development') {
        return (
          <div className="glass rounded-3xl p-6 text-center border-2 border-red-300">
            <p className="text-red-600 font-semibold">Error loading content</p>
            <p className="text-xs text-gray-500 mt-2">{this.state.error?.message}</p>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              className="mt-2 text-teal hover:underline text-sm"
            >
              Try again
            </button>
          </div>
        );
      }
      
      // In production, show generic message and skip this item
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
